
import { inboxService } from "@/shared/services/api/inbox-service";
import {  IGetInboxRequest } from "@/shared/services/interface/requests/IInboxRequest";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getInbox = createAsyncThunk(
  "inbox/getInbox",
  async (request: IGetInboxRequest, thunkAPI) => {
    try {
      const response = await inboxService.getInbox({
        userId: request.userId,
        isRead: request.isRead,
        isGrouped: true,
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getInfiniteInbox = createAsyncThunk(
  "inbox/getInfiniteInbox",
  async (request: IGetInboxRequest, thunkAPI) => {
    try {
      const response = await inboxService.getInbox({
        userId: request.userId,
        isRead: request.isRead,
        isGrouped: true,
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getActivities = createAsyncThunk(
  "inbox/getActivities",
  async (request: IGetInboxRequest, thunkAPI) => {
    try {
      const response = await inboxService.getInbox({
        userId: request.userId,
        isRead: request.isRead,
        isGrouped: false,
        targetId: request.targetId,
      });
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const markAsRead = createAsyncThunk(
  "inbox/markAsRead",
  async (inboxId: string, thunkAPI) => {
    try {
      const response = await inboxService.markAsRead(inboxId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const toggleFavorite = createAsyncThunk(
  "inbox/toggleFavorite",
  async (inboxId: string, thunkAPI) => {
    try {
      const response = await inboxService.toggleFavorite(inboxId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteInbox = createAsyncThunk(
  "inbox/delete",
  async (inboxId: string, thunkAPI) => {
    try {
      const response = await inboxService.delete(inboxId);
      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);